 <template>
     <div class="review-viewport" v-bind:class="statusClass(this.review.ModerationStatus)" v-cloak>
        <div class="review-row">
         <div class="review-content" v-if="review">
             <div class="review-status" v-if="this.review.ModerationStatus != ''">{{ this.review.ModerationStatus }}</div>
             <div class="review-status" v-else>PENDING</div>
             <div class="review-subject" v-if="this.review.Title !== ''">{{ this.review.Title }}</div>
             <div class="review-subject" v-else>Service Review</div>
             <div class="review-date">{{ formatDate(this.review.SubmissionTime) }}</div>
             <review-stars :score="this.review.Rating" :totalScore="5"></review-stars>
             <div class="customer-reviews">
                 <h2>Review Details</h2>
                 <div class="chart">
                     <div class="area">
                         <div class="name">Professionalism</div>
                         <div class="bar">
                             <div class="fill" v-bind:style="{ width: this.review.Professionalism * 42.4 + 'px' }">{{ this.review.Professionalism }}</div>
                         </div>
                     </div>
                     <div class="area">
                         <div class="name">Knowledge</div>
                         <div class="bar">
                             <div class="fill blue" v-bind:style="{ width: this.review.Knowledge * 42.4 + 'px' }">{{ this.review.Knowledge }}</div>
                         </div>
                     </div>
                     <div class="area">
                         <div class="name">Responsiveness</div>
                         <div class="bar">
                             <div class="fill green" v-bind:style="{ width: this.review.Responsiveness * 42.4 + 'px' }">{{ this.review.Responsiveness }}</div>
                         </div>
                     </div>
                     <div class="area">
                         <div class="name">Level of Service</div>
                         <div class="bar">
                             <div class="fill green-more" v-bind:style="{ width: this.review.LevelOfService * 42.4 + 'px' }">{{ this.review.LevelOfService }}</div>
                         </div>
                     </div>
                 </div>
                 <div class="options">
                     <div class="name">Rates Honored</div>
                     <div class="value">{{ this.review.RatesHonored }}</div>
                     <div class="clearfix"></div>
                     <div class="name">Would Recommend</div>
                     <div class="value">{{ this.review.IsRecommended }}</div>
                     <div class="clearfix"></div>
                     <div class="name">Mortgage Closed</div>
                     <div class="value">{{ this.review.WasMortgageClosed }}</div>
                     <div class="clearfix"></div>
                     <div class="name">Closed On Time</div>
                    <div class="value">{{ this.review.WasClosedOnTime }}</div>
                 </div>
             </div>
             <div class="review-text">
                 <span class="reviewText">
                   {{ reviewText }}
                   <template v-if="needShowMoreLess">
                     <a v-if="!showingAll" class="text-show-more" title="Show more..." v-on:click="toggleView()">...</a>
                     <a v-else title="Show less" class="text-show-less" v-on:click="toggleView()">show less</a>
                   </template>
                 </span>
             </div>
             <div class="reviewerName"> -- {{ this.review.UserNickname }}</div>
             <review-response v-for="clientResponse in this.review.ClientResponses" :key="clientResponse.Id"
                              :response="clientResponse.Response"
                              :submissionTime="clientResponse.ResponseDate"></review-response>
             <div class="advertiser-response-form">
                 <form method="post" @submit.prevent="submitNewReview">
                     <div class="row">
                         <div class="col-md-12">
                             <div class="form-group">
                                 <input type="text" name="newResponse" class="form-control response" placeholder="Click to respond" required v-model="newResponse">
                             </div>
                         </div>
                         <div class="col-md-12">
                             <button type="submit" class="btn btn-success btn-add-response" data-style="expand-left">Respond</button>
                             <a class="cancelLnk" href v-on:click.prevent="onClear">Cancel</a>
                         </div>
                     </div>
                 </form>
             </div>
         </div>
    </div>
     </div>
</template>

<script>
    import ReviewStars from "./review-stars.vue";
    import ReviewResponse from "./review-response";

    export default {
        components: {ReviewResponse, ReviewStars},
        data: () => {
            return {
                newResponse: null,
                showingAll: false,
            };
        },
        props: {
            'review': {
                type: Object,
                required: true
            },
        },
        computed: {
          needShowMoreLess() {
            return this.review.ReviewText.length > 440
          },

          reviewText: function () {
            return this.showingAll ? this.review.ReviewText : this.review.ReviewText.substring(0, 440)
          }
        },
        name: 'consumer-review',
        methods: {
            toggleView: function () {
              this.showingAll = !this.showingAll;
            },
            statusClass: function (status) {
                if (status == 'APPROVED') {
                    return 'status-approved';
                } else if (status == 'REJECTED') {
                    return 'status-rejected';
                }
                return '';
            },
            formatDate(date) {
                return moment(date).format('MM/DD/YYYY hh:mm')
            },
            submitNewReview: function() {
                this.$http
                    .post(route("api.tools.reviews.addResponse"), {
                        reviewId: this.review.Id,
                        response: this.newResponse
                    })
                    .then(data => {
                        this.review.ClientResponses = data.body.ClientResponses;
                        this.newResponse = '';
                    })
                    .catch(e => console.error(e.message));
            },
            onClear: function() {
                this.newResponse = null;
            },
        },
    };
</script>

 <style scoped>
    .text-show-more, .text-show-less {
        cursor: pointer;
    }
 </style>
